import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DasUBoot} from "../DasUBoot";
import {gsap} from "gsap";
import {DasUBootRoundType} from "../server/DasUBootData";
import {MiniLampState} from "../view/parts/SpineLamp";

/**
 * Created by jonas on 2021-03-10.
 */

export class TorpedoPartsPresentation implements SimplePresentation {

    start(controller:SimplePresentationRunnerController):void {

        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish(), paused:true});

        tl.add(() => controller.setSkipCallback(() => tl.seek("end", false)));
        tl.add(TorpedoPartsPresentation.getAddPartsAnimation());
        tl.addLabel("end");

        tl.play();
    }

    private static getAddPartsAnimation():gsap.core.Timeline {
        const addParts = gsap.timeline();
        let count = 0;
        for (let data of DasUBoot.model.clientData.torpedoParts) {
            if (data){
                count++;
                if (data.addedThisSpin) {
                    addParts.add(DasUBoot.reelView.reelFrame.torpedoView.activatePart(0.5, data.reel, data.size, data.addedThisSpin.fallSize,  data.addedThisSpin.position), "<0.2");
                }
            }
        }

        if (count >= 3){
            addParts.add([
                DasUBoot.reelView.reelFrame.torpedoView.getHatchAnimation(true),
                ()=>DasUBoot.reelView.reelFrame.switchMiniLamps(MiniLampState.YELLOW, [0,5])
            ]);
        }

        return addParts;
    }

    shouldRun():boolean {
        return DasUBoot.model.data.roundType == DasUBootRoundType.SUPER_FREE_SPIN;
    }


}